import { render, staticRenderFns } from "./SortParameters.vue?vue&type=template&id=266785e9&scoped=true&"
import script from "./SortParameters.vue?vue&type=script&lang=ts&"
export * from "./SortParameters.vue?vue&type=script&lang=ts&"
import style0 from "./SortParameters.vue?vue&type=style&index=0&id=266785e9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266785e9",
  null
  
)

export default component.exports